import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useGetUserSessions } from "@/hooks/api/query/useGetUserSessions";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: sessions, isLoading } = useGetUserSessions(user?.id);

  useEffect(() => {
    if (!isLoading && sessions !== undefined) {
      const hasFormSessions = sessions.length > 0;
      if (hasFormSessions) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/ghid-nis2", { replace: true });
      }
    }
  }, [user, sessions, isLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
